import { defineMessages } from 'react-intl';

/** The copy of the Spotify header in the Studio and the viewer (design spotify-header a1 to a6). */
export const spotifyHeaderMessages = defineMessages({
  pictureTitle: { id: 'app.sml.promote.studio.spotifyHeader.picture.title', defaultMessage: 'Picture' },
  pictureHint: {
    id: 'app.sml.promote.studio.spotifyHeader.picture.hint',
    defaultMessage: 'What fills your header. Spotify asks for no text and no logos, so the header has none.',
  },
  sourceCover: { id: 'app.sml.promote.studio.spotifyHeader.source.cover', defaultMessage: 'Blurred cover' },
  sourceCoverBenefit: {
    id: 'app.sml.promote.studio.spotifyHeader.source.cover.benefit',
    defaultMessage: 'Your cover, softened across the whole header. Its colours, none of its words.',
  },
  sourcePhoto: { id: 'app.sml.promote.studio.spotifyHeader.source.photo', defaultMessage: 'Your photo' },
  sourcePhotoBenefit: {
    id: 'app.sml.promote.studio.spotifyHeader.source.photo.benefit',
    defaultMessage: 'A photo of you. Fans click a face first.',
  },
  sourceBank: { id: 'app.sml.promote.studio.spotifyHeader.source.bank', defaultMessage: 'Picture bank' },
  sourceBankBenefit: {
    id: 'app.sml.promote.studio.spotifyHeader.source.bank.benefit',
    defaultMessage: 'A picture from our bank that fits your theme.',
  },
  sourceAi: { id: 'app.sml.promote.studio.spotifyHeader.source.ai', defaultMessage: 'AI picture' },
  sourceAiBenefit: {
    id: 'app.sml.promote.studio.spotifyHeader.source.ai.benefit',
    defaultMessage: 'A picture made for this song in the cover editor.',
  },
  sourceTheme: { id: 'app.sml.promote.studio.spotifyHeader.source.theme', defaultMessage: 'Theme colours' },
  sourceThemeBenefit: {
    id: 'app.sml.promote.studio.spotifyHeader.source.theme.benefit',
    defaultMessage: 'A calm field in the colours of your theme.',
  },
  bankTitle: { id: 'app.sml.promote.studio.spotifyHeader.bank.title', defaultMessage: 'Picture bank' },
  bankHint: {
    id: 'app.sml.promote.studio.spotifyHeader.bank.hint',
    defaultMessage: 'Pictures that fit {theme} come first. Free to use.',
  },
  bankEmpty: {
    id: 'app.sml.promote.studio.spotifyHeader.bank.empty',
    defaultMessage: 'The picture bank is empty right now. Pick another picture.',
  },
  aiTitle: { id: 'app.sml.promote.studio.spotifyHeader.ai.title', defaultMessage: 'AI pictures of {title}' },
  aiHint: {
    id: 'app.sml.promote.studio.spotifyHeader.ai.hint',
    defaultMessage: 'Made in the cover editor. A header uses one at no extra cost.',
  },
  aiNone: {
    id: 'app.sml.promote.studio.spotifyHeader.ai.none',
    defaultMessage: 'No AI pictures for {title} yet.',
  },
  aiOpenEditor: { id: 'app.sml.promote.studio.spotifyHeader.ai.openEditor', defaultMessage: 'Open the cover editor' },
  pickPicture: { id: 'app.sml.promote.studio.spotifyHeader.pickPicture', defaultMessage: 'Picture {number}' },
  photoTitle: { id: 'app.sml.promote.studio.spotifyHeader.photo.title', defaultMessage: 'Your photo' },
  photoHint: {
    id: 'app.sml.promote.studio.spotifyHeader.photo.hint',
    defaultMessage: 'A JPG or PNG, 2660 px wide or more is best.',
  },
  useProfilePhoto: {
    id: 'app.sml.promote.studio.spotifyHeader.photo.useProfile',
    defaultMessage: 'Use my profile photo',
  },
  useProfilePhotoHint: {
    id: 'app.sml.promote.studio.spotifyHeader.photo.useProfileHint',
    defaultMessage: 'The photo of {artist} in Settings → Artist',
  },
  useIt: { id: 'app.sml.promote.studio.spotifyHeader.photo.useIt', defaultMessage: 'Use it' },
  inUse: { id: 'app.sml.promote.studio.spotifyHeader.photo.inUse', defaultMessage: 'In use' },
  dropTitle: { id: 'app.sml.promote.studio.spotifyHeader.photo.dropTitle', defaultMessage: 'Drop a photo here' },
  dropHint: {
    id: 'app.sml.promote.studio.spotifyHeader.photo.dropHint',
    defaultMessage: 'Or pick a file. The photo stays private to your workspace.',
  },
  choosePhoto: { id: 'app.sml.promote.studio.spotifyHeader.photo.choose', defaultMessage: 'Choose a photo' },
  uploading: { id: 'app.sml.promote.studio.spotifyHeader.photo.uploading', defaultMessage: 'Uploading…' },
  uploadFailed: {
    id: 'app.sml.promote.studio.spotifyHeader.photo.failed',
    defaultMessage: 'We could not read this file. Use a JPG or PNG photo.',
  },
  smallPhoto: {
    id: 'app.sml.promote.studio.spotifyHeader.photo.small',
    defaultMessage: 'This photo is {width} px wide. Spotify asks for 2660 px, so the header will look soft.',
  },
  positionTitle: { id: 'app.sml.promote.studio.spotifyHeader.position.title', defaultMessage: 'Position' },
  positionHint: {
    id: 'app.sml.promote.studio.spotifyHeader.position.hint',
    defaultMessage: 'Move the picture until the subject sits in the green box. Spotify puts your name bottom left.',
  },
  upDown: { id: 'app.sml.promote.studio.spotifyHeader.position.upDown', defaultMessage: 'Up / down' },
  leftRight: { id: 'app.sml.promote.studio.spotifyHeader.position.leftRight', defaultMessage: 'Left / right' },
  desktop: { id: 'app.sml.promote.studio.spotifyHeader.preview.desktop', defaultMessage: 'Desktop' },
  phone: { id: 'app.sml.promote.studio.spotifyHeader.preview.phone', defaultMessage: 'Phone' },
  file: { id: 'app.sml.promote.studio.spotifyHeader.preview.file', defaultMessage: 'File' },
  viewLabel: { id: 'app.sml.promote.studio.spotifyHeader.preview.view', defaultMessage: 'Preview on' },
  showName: {
    id: 'app.sml.promote.studio.spotifyHeader.preview.showName',
    defaultMessage: 'Show my name and photo',
  },
  cropGuides: { id: 'app.sml.promote.studio.spotifyHeader.preview.guides', defaultMessage: 'Crop guides' },
  legendSafe: {
    id: 'app.sml.promote.studio.spotifyHeader.legend.safe',
    defaultMessage: 'The part that every screen shows. Keep faces here.',
  },
  legendCrop: {
    id: 'app.sml.promote.studio.spotifyHeader.legend.crop',
    defaultMessage: 'Phones show the middle; desktops cut the top and the bottom.',
  },
  legendName: {
    id: 'app.sml.promote.studio.spotifyHeader.legend.name',
    defaultMessage: 'Spotify draws your photo and name here.',
  },
  safeLabel: { id: 'app.sml.promote.studio.spotifyHeader.safeLabel', defaultMessage: 'Keep your face here' },
  verified: { id: 'app.sml.promote.studio.spotifyHeader.overlay.verified', defaultMessage: 'Verified artist' },
  honestNote: {
    id: 'app.sml.promote.studio.spotifyHeader.note',
    defaultMessage:
      'Spotify crops each screen in its own way and does not publish the exact crop. The guides are our best measure; check the preview in Spotify for Artists before you save.',
  },
  freeNote: {
    id: 'app.sml.promote.studio.spotifyHeader.freeNote',
    defaultMessage:
      'Spotify asks for 2660 x 1140 with no logos. Free makes a half-size preview with the MUSIC24 mark. Upgrade to get the full-size file with no mark.',
  },
  previewAlt: { id: 'app.sml.promote.studio.spotifyHeader.preview.alt', defaultMessage: 'Your Spotify header' },
});
